import { Route, Routes, Navigate } from 'react-router-dom';
import Login from "../pages/Auth/Login";
import EmailVerification from '../pages/Auth/EmailVerification';
import ChangePassword from '../pages/Auth/ChangePassword';
import OtpVerification from '../pages/Auth/OtpVerification';
import ResetPassword from '../pages/Auth/ResetPassword';
import Dashboard from '../pages/Dashboard';
import SchoolPayments from '../pages/SchoolPayments';
import Transactions from '../pages/Transactions';
import ActivityLog from '../pages/ActivityLog';
import UserManagement from '../pages/UserManagement';
import WalletManagement from '../pages/WalletManagement';
import AdminManagement from '../pages/AdminManagement';
import ProtectedRoutes from './ProtectedRoutes';
import OtpAndResetProtectedRoute from './OtpAndResetProtectedRoutes';


const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/auth/change-password" element={<ChangePassword />} />
      <Route path="/auth/activate-account" element={<EmailVerification />} />

      <Route element={<OtpAndResetProtectedRoute />}>
        <Route path="/auth/otp-verification" element={<OtpVerification />} />
        <Route path="/auth/reset-password" element={<ResetPassword />} />
      </Route>

      <Route element={<ProtectedRoutes />}>
        <Route path="/admin/dashboard" element={<Dashboard />} />
        <Route path="/admin/school-payments" element={<SchoolPayments />} />
        <Route path="/admin/transactions" element={<Transactions />} />
        <Route path="/admin/activity-log" element={<ActivityLog />} />
        <Route path="/admin/user-management" element={<UserManagement />} />
        <Route path="/admin/wallet-management" element={<WalletManagement />} />
        <Route path="/admin/admin-management" element={<AdminManagement />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;